<style lang="scss">
@import "../../../../sass/layout/tables";
.org-width {
  /* max-width: 180px; */
  word-wrap: break-word;
}
</style>

<template>
  <div class="users-list table-template">
    <BFormGroup horizontal label="Filter" class="d-md-none not-generic-form">
      <BInputGroup>
        <BFormSelect v-model="sortBy" :options="sortFields">
          <option slot="first" :value="null">-- Filter --</option>
        </BFormSelect>
        <BFormSelect :disabled="!sortBy" v-model="sortDesc" slot="append">
          <option :value="false">Asc</option>
          <option :value="true">Desc</option>
        </BFormSelect>
      </BInputGroup>

      <BInputGroup class="border-search">
        <BFormInput
          v-model="filter"
          placeholder="Search by County or Consultant Name"
        />
        <BInputGroup-append>
          <i class="fa fa-search my-auto"></i>
        </BInputGroup-append>
      </BInputGroup>
    </BFormGroup>

    <div class="row rounded-top consultants">
      <div class="arrow-consultants">
        <img :src="'/images/orange_arrow_blue_border.png'" />
        <span class="table-title">Consultants</span>
      </div>
      <div class="border-search d-none d-md-block">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="filter"
            placeholder="Search by County or Consultant Name"
          />
          <div class="input-group-append">
            <i class="fa fa-search my-auto"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-center border border-info border-top-0"
      v-if="loading"
    >
      <div class="fa-3x pt-3 pb-1">
        <i class="fas fa-spinner fa-pulse" style="color: #91ccda"></i>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <BTable
          stacked="md"
          :fields="fields"
          :items="users"
          empty-filtered-text="No Consultants match filters"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template v-slot:cell(name)="data">
            <a v-bind:href="$basePath + '/consultants/' + data.item.id">{{
              data.item.name
            }}</a>
          </template>
          <template v-slot:cell(organization_type)="data">
            {{
              data.item.organization_type
                ? data.item.organization_type.name
                : "--"
            }}
          </template>
          <template v-slot:cell(connections)="data">
            {{ data.item.program_count ? data.item.program_count : 0 }} Programs
            Connected <br />
            {{ data.item.child_count ? data.item.child_count : 0 }} Children
            Served
          </template>
          <template v-slot:cell(counties_served)="data">
            <div v-if="data.item.counties_served">
              <div v-for="(county_served, index) in data.item.counties_served">
                <span v-show="data.item.show_all_counties || index < 3">{{
                  county_served.name
                }}</span
                ><span
                  v-if="index + 1 < data.item.counties_served.length"
                  v-show="data.item.show_all_counties || index < 3"
                  >,
                </span>
              </div>
              <span
                v-if="data.item.counties_served.length > 3"
                v-on:click="toggleShowCounties(data.item)"
              >
                <span v-if="data.item.show_all_counties" class="btn-link small"
                  >less</span
                >
                <span v-else class="btn-link">...</span>
              </span>
            </div>
          </template>
          <template v-slot:cell(latest_activity_log)="data">
            <div v-if="data.item.latest_activity_log">
              <!-- <span>{{ data.item.latest_activity_log.date }}</span> -->
              <span>{{ formatDate(data.item.latest_activity_log.date) }}</span>
            </div>
            <div v-else>--</div>
          </template>
        </BTable>
      </div>
      <BRow class="pagination-row justify-content-center">
        <BPagination
          :total-rows="this.users.length"
          :per-page="perPage"
          v-model="currentPage"
          hide-goto-end-buttons
        />
      </BRow>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  components: {
    moment,
  },
  data: function () {
    return {
      users: [],
      fields: [
        { key: "name", label: "Consultant Name", sortable: true },
        {
          key: "organization_type",
          label: "Organization Type",
          sortable: true,
          class: "org-width",
        },
        { key: "connections", label: "Connections", sortable: true },
        { key: "counties_served", label: "County", sortable: true },
        { key: "latest_activity_log", label: "TA Activity", sortable: true },
      ],
      state: this.state,
      currentPage: 1,
      perPage: 5,
      loading: true,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      loading: true,
    };
  },
  methods: {
    fetchUsers: function () {
      axios
        .get(
          "/api/consultants/list?with=connections,countiesServed,organizationType,program,program.consultants,program.county"
        )
        .then(
          function (response) {
            this.users = response.data.data;
            console.log(this.users);
            this.loading = false;
          }.bind(this)
        )
        .catch(function (error) {
          console.error(error);
        });
    },
    toggleShowCounties: function (data) {
      //this.show_all_counties = !this.show_all_counties;
      if (data.hasOwnProperty("show_all_counties")) {
        data.show_all_counties = !data.show_all_counties;
      } else {
        //since its the first time , set the value pf show_all_counties to true to show the subitem
        //data = Object.assign({}, data, {show_all_counties: false});
        //Vue.set(data, 'show_all_counties', false);
        this.$set(data, "show_all_counties", true);
      }
    },
    formatDate(value) {
      try {
        if (value) {
          return moment(String(value)).format("MM/DD/YYYY");
        }
      } catch (error) {
        return value;
      }
    },
  },
  computed: {
    sortFields: function () {
      if (this.fields) {
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return { text: f.label, value: f.key };
          });
      }
      return new Array();
    },

    $basePath() {
      return window.basePath;
    },
  },
  mounted: function () {
    this.fetchUsers();
  },
};
</script>